import mutate from '@/utils/mutateWrapper'
import { CREATE_ORDER_MUTATION } from '../gql/orders.gql'

export const createOrder = data => mutate(CREATE_ORDER_MUTATION, { data })
